export default __webpack_public_path__ + "static/media/bg.af4f56b3.svg";